// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import bus from './utils/bus.js';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/elementui_fonts/style.css'
import "@webdatarocks/webdatarocks/webdatarocks.css";

import i18n from './common/i18n'

import wxlogin from 'vue-wxlogin';

import Print from '@/plugins/print-compatible.js';
Vue.use(Print)


import userDefinedDirective from '@/utils/userDefinedDirective.js';
Vue.use(userDefinedDirective)

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});   //全部引入   可以根据需求按需引入

// import VueCompositionAPI from '@vue/composition-api'
// Vue.use(VueCompositionAPI)
import { checkPermission } from '@/utils/permission.js'

Vue.prototype.$checkPermission = checkPermission      //全局检验权限方法
Vue.config.productionTip = false;
Vue.config.productionTip = false;

Vue.prototype.$bus = bus;
Vue.prototype.$showTittle = '';
Vue.prototype.$showType = null;


/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})

// 通过bus也可以访问到app，方便一些函数的封装
bus.app = app;



// WEBPACK FOOTER //
// ./src/main.js